import React from 'react';

type BorderProps = {
	color: string;
	size: number;
};

function Border({size, color}: BorderProps): React.JSX.Element {
	const c = Math.sqrt(3) / 2;
	const half = size / 2;
	const strokeWidth = size / 12;
	const top = strokeWidth / 2;
	const bottom = size - strokeWidth / 2;
	const xMax = half + half * c;
	const xMin = half - half * c;
	const yMax = half * 1.5;
	const yMin = half * 0.5;
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" height={size} width={size}>
			<path
				stroke={color}
				strokeWidth={strokeWidth}
				fill="none"
				d={`M${half} ${top} L${xMax} ${yMin} L${xMax} ${yMax} L${half} ${bottom} L${xMin} ${yMax} L${xMin} ${yMin} Z`}
			/>
		</svg>
	);
}

type ProfilePictureWithBorderProps = {
	profilePicture: string;
	borderColor: string;
	size: number;
};

export function ProfilePictureWithBorder({
	profilePicture,
	borderColor,
	size,
}: ProfilePictureWithBorderProps): React.JSX.Element {
	return (
		<div className="img-wrapper">
			<div className="image-container" style={{height: size, width: size}}>
				<img src={profilePicture} height={size} alt="owner" />
			</div>
			<div className="svg-container" style={{height: size, width: size}}>
				<Border size={size} color={borderColor} />
			</div>
		</div>
	);
}
